export const SUPPORTED_LANGUAGES = ['en', 'nl', 'de', 'fr', 'it', 'es', 'pt'];

/**
 * Updates the HTML lang attribute and translation prevention attributes
 * @param {string} language - Language code (e.g., 'en', 'nl', 'de', etc.)
 */
export const updateHtmlLanguageAttributes = (language) => {
  const html = document.documentElement;
  const langCode = language.toLowerCase();

  // Update language attribute
  html.setAttribute('lang', langCode);
};

/**
 * Determines the best language to use based on user preference and browser settings
 * @param {string} userLanguage - User's preferred language from profile
 * @param {string} browserLanguage - Browser's language setting
 * @param {string} fallbackLanguage - Fallback language (default: 'en')
 * @returns {string} Language code to use
 */
export const determineLanguageToUse = (
  userLanguage = null,
  browserLanguage = null,
  fallbackLanguage = 'en'
) => {
  // Priority 1: User's stored language preference
  if (
    userLanguage &&
    SUPPORTED_LANGUAGES.includes(userLanguage.toLowerCase())
  ) {
    return userLanguage.toLowerCase();
  }

  // Priority 2: Browser language if supported
  if (browserLanguage) {
    const browserLang = browserLanguage.split('-')[0].toLowerCase();
    if (SUPPORTED_LANGUAGES.includes(browserLang)) {
      return browserLang;
    }
  }

  // Priority 3: Fallback language
  return fallbackLanguage;
};

/**
 * Prevents browser translation by setting multiple attributes and meta tags
 */
